<template>
  <v-dialog
    v-model="visible"
    max-width="400px"
    persistent
  >
    <v-card class="pa-3">
      <h4>
        {{ report.titulo }}  ({{ report.fecha | parseDate }})
      </h4>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="files"
        :pagination.sync="pagination"
        :search="search"
        rows-per-page-text="Documentos por pagina"
        :rows-per-page-items="[5,10,25,{ text: 'Todos', value: -1 }]"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">
            {{ props.item.titulo }}
          </td>
          <td class="text-xs-left">
            <v-btn
              icon
              class="primary"
              small
              @click="downloadFile(props.item.url)"
            >
              <v-icon>arrow_downward</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
      <div class="text-xs-right mt-4">
        <v-btn
          class="primary"
          :disabled="loading"
          @click="closeModal"
        >
          Cerrar
        </v-btn>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  name: 'ReportFilesTableModal',
  filters: {
    parseDate (val) {
      return moment(val).format('DD-MM-YYYY')
    }
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    report: {
      type: Object,
      required: true
    },
    files: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Archivos', value: 'titulo' },
        { text: '', value: null, sortable: false }
      ],
      search: '',
      pagination: { sortBy: 'titulo', descending: true }
    }
  },
  computed: {
    ...mapGetters(['user'])
  },
  methods: {
    downloadFile (url) {
      window.open(url, '_blank')
    },
    closeModal () {
      this.$emit('cancel')
    }
  }
}
</script>
